import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';

import { Program } from 'src/app/shared/models';

@Component({
  selector: 'fc-dialog-edit-programs',
  templateUrl: './dialog-edit-programs.component.html',
  styleUrls: ['./dialog-edit-programs.component.scss'],
})
export class EditProgramsDialogComponent {
  @ViewChild('programInput') programInput: ElementRef<HTMLInputElement>;
  regionId: number = null;
  selectedProgramIds: number[] = [];
  other: string = null;
  selectedPrograms: Program[] = [];

  constructor(public dialogRef: MatDialogRef<EditProgramsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.regionId = data.regionId;
      this.selectedPrograms = cloneDeep(data.programs);
      if (data.other) {
        this.selectedPrograms.push(...data.other.split(',').map(p => new Program({ name: p })));
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  apply(): void {
    this.dialogRef.close({
      selectedProgramIds: this.selectedPrograms.filter(p => p.id).map(p => p.id),
      other: this.selectedPrograms
        .filter(p => !p.id)
        .map(p => p.name)
        .join(','),
    });
  }

  selectProgram(programs: Program[]) {
    this.selectedPrograms = programs;
  }
}
